// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__6qcpE","wrapper":"Footer_wrapper__gjBDw","devs_block":"Footer_devs_block__auLRt","devs":"Footer_devs__OMUqP","year":"Footer_year__NgeP+"};